import { useProjectStageStore } from '@/components/common/menu/lib/store/useProjectStageStore.tsx'
import { useProjectStageFiltersStore } from '@/components/common/menu/lib/store/useProjectStageFilters.ts'
import { useNavigate } from 'react-router-dom'
import { useUserStore } from '@/store/user.ts'
import { useLocallyStoredFilters } from '@/routes/projectStages/issues/lib/stores/useLocallyStoredFilters.ts'
import { useGetUserProjectParticipations } from '@/lib/actions/getUserProjectParticipations.ts'
import somethingWrong from '@/lib/helpers/somethingWrong.ts'
import { createProjectTab } from '@/components/common/stageTabs/StageTabTrigger.tsx'
import createIssueTypesLinks from '@/lib/helpers/createIssueTypesLinks.tsx'
import { queryClient } from '@/lib/api-client.ts'
import { currStageIssueTypesQuery } from '@/lib/actions/getStageIssuesTypes.ts'
import { IssueTypeT } from '@/components/common/menu/lib/types/navigationDataTypes.ts'

export default function useNavStagesData() {
  const currProjectStage = useProjectStageStore(state => state.currProjectStage)
  const stagesProperties = useProjectStageFiltersStore(state => state.stagesProperties)
  const selected = stagesProperties.find(stage => stage.value == String(currProjectStage?.id))
  const updateActiveTab = useLocallyStoredFilters(state => state.updateActiveTab)

  // const storedTabs = useLocallyStoredFilters(state => state.tabs)
  // const setActiveTabId = useLocallyStoredFilters(state => state.setActiveTabId)

  const navigate = useNavigate()
  const userId = useUserStore(state => state.user)?.id
  const setCurrProjectStage = useProjectStageStore(state => state.setCurrProjectStage)

  const { projectParticipationsFlat } = useGetUserProjectParticipations()

  function onSelect(val: string) {
    const projectStage = projectParticipationsFlat?.find(
      participation => String(participation?.projectStage?.id) === val,
    )?.projectStage
    if (!projectStage) return somethingWrong(`on select project stage`)

    const defaultPath = `/project_stages/${val}/dashboard`

    // Read any cached issue types synchronously so the tab starts with the
    // right links. Missing cache just means fewer links until the route
    // loader hydrates the store. Keeping this sync guarantees the
    // navigate() call below is never skipped (e.g. if the popover unmounts
    // while awaiting a fetch).
    const issueTypesQuery = currStageIssueTypesQuery(projectStage.id)
    const cachedIssueTypes = queryClient.getQueryData<IssueTypeT[]>(issueTypesQuery.queryKey)
    const links = createIssueTypesLinks(
      projectStage,
      cachedIssueTypes ?? null,
    ).projectStageIssuesLinks

    setCurrProjectStage(projectStage)
    const stageTab = createProjectTab(defaultPath, projectStage, userId as number, links ?? [])
    updateActiveTab(stageTab)
    navigate(defaultPath)
  }
  const stageId = String(currProjectStage?.id)

  return {
    stagesProperties,
    selected,
    onSelect,
    stageId,
  }
}
